import { useEffect, useMemo, useState } from "react";
import FilterGameList from "../../utils/FilterGameType";
import GameSelect from "./GameSelect";
import Games from "./Games";
import PlatformSelect from "./PlatformSelect";
import LoaderComponent from "../Loading/LoaderComponent";
import { useLocation } from "react-router";
import Carousel from "../Carousel";
import { useSelector } from "react-redux";
import SupplierList from "./SupplierList";
import CommonBorder from "../BorderComponent/CommonBorder";
import SearchItem from "../EventListSelect/SearchItem";
import { Input } from "semantic-ui-react";
import SearchBox from "../EventListSelect/SearchBox";
import GameCatalog from "../GameCatalog";
import GetParams from "../../utils/getParams";
import { RiArrowDropRightFill } from "react-icons/ri";
import { IoFilterSharp } from "react-icons/io5";
import { MdFilterListAlt } from "react-icons/md";
import FilterGame from "./FilterGame";
import { useTranslation } from "react-i18next";
const GamePage = ({ platformType, specialColor }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const games = FilterGameList({ TYPE: platformType });
  const gameList = useSelector((state) => state.isGameList);

  // const platform = GetParams("platform");

  const [searchValue, setSearchValue] = useState("");
  const [sort, setSort] = useState("");
  const [platform, setPlatform] = useState(GetParams("platform") ?? "");

  const extractArrayWithGameType = (obj, type) => {
    const result = [];

    const entries = Object.entries(obj);
    for (const [key, value] of entries) {
      if (key === type && Array.isArray(value)) {
        result.push(...value);
      } else if (typeof value === "object" && value !== null) {
        result.push(...extractArrayWithGameType(value, type));
      }
    }

    return result;
  };
  const typeGameList = extractArrayWithGameType(gameList, platformType);

  const CQ9_GAME = useMemo(() => {
    return gameList?.["CQ9"]?.["SLOT"];
  }, [gameList]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [platform]);

  return (
    <main>
      <section className="py-common-padding-y hidden sm:block">
        <Carousel />
      </section>
      <section className="hidden sm:block">
        <section className="w-full min-h-[40px]">
          <div className="h-full py-common-padding-y w-full relative z-[998]">
            <Input
              iconPosition="left"
              onChange={(e) => setSearchValue(e.target.value)}
              className="w-full"
              icon={{ name: "search", circular: true, link: true }}
              input={{ className: "!bg-platform-bg" }}
              placeholder="The search term must be longer than three characters."
            ></Input>
          </div>
        </section>
        {searchValue.length > 2 && <SearchBox searchValue={searchValue} />}
      </section>
      <section className="py-common-padding-x">
        <GameSelect customScrollY={20} />
      </section>
      <section className="p-common-padding-x mb-[20px]">
        <div className="flex items-center justify-between mb-[20px]">
          <div className="flex items-center">
            <p className="text-xl font-semibold text-main-color italic mb-0">
              {platform ? platform : i18n("Allgame")}
            </p>
            <RiArrowDropRightFill className="text-4xl text-main-color" />
          </div>
          <div className="flex items-center">
            {/* <MdFilterListAlt className="text-2xl text-light-text" />
            <span className="text-light-text font-bold">排序</span> */}
            <FilterGame setSort={setSort} />
          </div>
        </div>

        <Games
          sort={sort}
          platform={platform}
          allGame={typeGameList}
          platformType={platformType}
          defaultPlatform={games?.[0]}
          specialColor={specialColor}
        />
      </section>
      <section className="px-common-padding-x mb-[20px]">
        <SupplierList setPlatform={setPlatform} LIST={games} />
      </section>
    </main>
  );
};

export default GamePage;
